import designSystem from './designSystemVariables'

const legacyTheme = {
  colors: {
    primary: '#5E9E95',
    green: '#5E9E95',
    greenLight: '#85B3BA',
    greenDark: '#365954',
    orange: '#f5a623',
    grey: '#f4f4f4',
    formGrey: '#F6F7F5',
    warmGrey: '#999999',
    borderGrey: '#DCD8D1',
    labelGrey: '#999999',
    textGreyLight: '#D5D5D5',
    textGreyDark: '#a9a9a9',
    textGreyDarker: '#1d1d1d',
    textGreySemiLight: '#D8D8D8',
    errorRed: '#ED5565',
    red: '#c00000',
    pending: '#ffb36b',
    success: '#48CFAD',
    carbon: '#333333',
    pink: '#FFE9E6',
    purple: '#634A70',
    olive: '#F8F6EC',
    metalChi: '#9b9b9b',
    offWhite: '#FCF6F1',
    white: '#ffffff',
    sand100: '#F9F5F2',
    cadetBlue: '#4EA699',
  },
  brand: {
    afterglow: '#ebceca',
    sunup: '#fec077',
    goldenglow: '#ffe379',
    jungle: '#0c6776',
    forest: '#0c393f',
    sky: '#97b2da',
    wetsand: '#c2b69c',
    sand: '#f7f8f6',
  },
  fonts: {
    default:
      '"GT Walsheim Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
  },
} as const

const theme = {
  ...legacyTheme,
  ...designSystem,
}

export default theme
